import React from 'react'
import ScrollOrigin from '../components/ScrollOrigin';
import styled from 'styled-components';
import { motion } from 'framer-motion';
// Components
import Nav from '../components/Nav';
import Footer from '../components/Footer';
// Team Photos
import Ipsita from '../icons/Ipsita.png';
import Samuel from '../icons/Samuel.png';
import Alex from '../icons/Alex.png';
import Daniel from '../icons/Daniel.png';
import { fade} from "../Animations";
import { pageTransition, transit } from "../animate";


const Team = () => {
    return (
        <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={pageTransition}
      transition={transit}
    >
        <Nav />
        <TeamPage >
        <h1>Meet the Team</h1>
        <TeamPhotos variants={fade}>
                <div>
                <a href="https://www.linkedin.com/in/ipsitahb/">
                <motion.img variants={fade} src={Ipsita} alt='Ipsita Bhargava' title="Linkedin"/>
                <h2>Ipsita Bhargava</h2>
                <h3>Project Manager</h3>
                <button>Linked-in</button>
                </a>
                </div>
                <div>
                <a href="https://www.linkedin.com/in/alexcude/">
                <motion.img variants={fade} src={Alex} alt='Alex Cude' title="Linkedin"/>
                <h2>Alex Cude</h2>
                <h3>Product Designer</h3>
                <button>Linked-in</button>
                </a>
                </div>
                <div>
                <a href="https://www.linkedin.com/in/samuel-olumorin/">
                <motion.img variants={fade} src={Samuel} alt='Samuel Olumorin' title="Linkedin"/>
                <h2>Samuel Olumorin</h2>
                <h3>Full-stack Developer</h3>
                <button>Linked-in</button>
                </a>
                </div>
                <div>
                <a href="https://www.linkedin.com/in/daniel-mason-dev/">
                <motion.img variants={fade} src={Daniel} alt='Daniel Mason' title="Linkedin"/>
                <h2>Daniel Mason</h2>
                <h3>Full-stack Developer</h3>
                <button>Linked-in</button>
                </a>
                </div>
        </TeamPhotos>
        </TeamPage>
        <Footer/>
        <ScrollOrigin/>
        </motion.div>
    )
}

export default Team

const TeamPage = styled.div`
min-height: 62.8vh;
display: flex;
align-items: center;
flex-direction: column;
line-height: 2rem;
    h1{
        text-align: center;
    }

    button {
        font-weight: normal;
        margin: 1rem 4rem;
        border-radius: 4rem;
        position: relative;
        z-index: 5;
        margin: 1rem auto;
        display: table;
        font-size: 2.5vh;
        border: .3vh none none;
        background: none;
        padding: 1vh 2.5vh;
        background-color: #35495B;
        color: #C8D1DA;
        border-radius: 1vh;
        outline: none;
        cursor: pointer;
        overflow: hidden;
        transition: all .2s ease-in-out .1s;
        
        &:hover {
            color: white;
            
            &:before {
            top: -300%;
            left: 70%;
            }
        }
        
        &:before {
            z-index: -999;
            position: absolute;
            top: -170%;
            left: -100%;
            width: 410px;
            height: 1000px;
            content: "";
            transform: rotate(-45deg);
            background: #5e9c98;
            transition: all .3s ease-in-out;
        }
            }
        `;

        const TeamPhotos = styled(motion.div)`
            display: flex;
            align-items: center;
            margin-top: 2rem;
            margin-bottom: 5.85rem;
            text-align: center;
`;

